import { Box, Button, useTheme } from '@mui/material'
import InfoIcon from '../../../assets/icons/i.svg?react'
import { useStoreActions } from '../../../store/hooks'

export const PuzzleQuestHeader: React.FC = () => {
    const setManualActiveFTUE = useStoreActions((state) => state.setManualActiveFTUE)
    const theme = useTheme()

    return (
        <Box
            sx={{
                position: 'relative',
                width: '100%',
                height: '80px',
                background: 'transparent',
                border: `3px solid ${theme.palette.orange.main}`,
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '0 16px',
            }}
        >
            {/* Puzzle Quest Icon */}
            <Box
                component="img"
                src="/assets/images/puzzle-quest/PQ-logo.svg"
                alt=""
                sx={{
                    position: 'absolute',
                    top: '-16px',
                    bottom: '0',
                    zIndex: '1299',
                }}
            />

            <Button
                startIcon={<InfoIcon style={{ transform: 'scale(1.4)' }} />}
                onClick={() => setManualActiveFTUE('/puzzle-quest')}
                onlyIcon={true}
                variant="contained"
                color="secondary"
                size="small"
                sx={{ position: 'absolute', right: '12px' }}
            />
        </Box>
    )
}
